export const maxTwentyCharsRegexp: RegExp = new RegExp(/^.{0,20}$/);
